import Vue from 'vue';
import WxSdk from '../../mars-activities/common/features/wx/sdk';
const ua = window.navigator.userAgent;
const isWx = /(?:micromessenger)/i.test(ua) && !/(?:wxwork)/i.test(ua);
if (isWx) {
  const wxSdk = new WxSdk({
    wxConfig: {
      openTagList: ['wx-open-launch-weapp']
    }
  });
  Vue.prototype.$wxSdk = wxSdk;
}
export function initPage(vueComponent) {
  new Vue({
    render: (h) => h(vueComponent)
  }).$mount('#app');
}
